import { ThirdPartyCollectSource } from '@tm/types/survey/third-party-collect'

/** Returns a predicate for sources that are in the main segment
 *
 * @param mainSegmentIds List of main segment identifiers the filtered source has to have. Empty ID list will result in all sources being returned.
 */
export const isSourceInMainSegment = (mainSegmentIds: string[]) => (source: ThirdPartyCollectSource) =>
  mainSegmentIds.length === 0 || !!source.mainSegmentIds?.some(id => mainSegmentIds.includes(id))
